"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isGameViewProviderProps = void 0;
function isGameViewProviderProps(props) {
    return !!props.RulesView;
}
exports.isGameViewProviderProps = isGameViewProviderProps;
